// # packages
import * as React from "react";

interface iProps {
  children: React.ReactNode | React.ReactNode[];
  title: string;
}

export default class AdminScene extends React.Component<iProps> {
  render() {
    const { children, title } = this.props;

    return (
      <div className="page-container">
        <h1 className="page-title">{title}</h1>
        {children}
      </div>
    );
  }
}
